import React, { useState } from "react";
import {
  Grid,
  Button,
  Popover,
  IconButton,
  Box,
  useMediaQuery,
} from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import CloseIcon from "@mui/icons-material/Close";
import FilterComponent from "./FilterComponent";
import DateRangeSlider from "./DateRangeSlider";
import AOISelector from "./AOISelector";

const HomeFilters = ({
  onFilterChange,
  filterData,
  observationData,
  onDateRangeSelected,
  onAOISelected,
  AOIData,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const isSmallScreen = useMediaQuery("(max-width:1400px)");

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const filtersContent = (
    <Box sx={{ padding: 2, width: "100%", position: "relative" }}>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <Grid
        container
        direction="column"
        alignItems="center"
        justifyContent="center"
        spacing={2}
      >
        <Grid item xs={12}>
          <FilterComponent
            onFilterChange={onFilterChange}
            filterData={filterData}
            observationData={observationData}
          />
        </Grid>
        <Grid item xs={12}>
          <DateRangeSlider
            onDateRangeSelected={onDateRangeSelected}
            dataSource={observationData}
          />
        </Grid>
        <Grid item xs={12}>
          <AOISelector onAOISelected={onAOISelected} AOIData={AOIData} />
        </Grid>
      </Grid>
    </Box>
  );

  return (
    <>
      {isSmallScreen ? (
        <>
          <Button
            variant="contained"
            onClick={handleOpen}
            startIcon={<FilterListIcon />}
          >
            Filters
          </Button>
          <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            slotProps={{
              paper: {
                sx: {
                  borderRadius: 2,
                  backgroundColor: "white",
                  position: "absolute",
                  width: 300,
                  maxWidth: "calc(100% - 32px)",
                },
              },
            }}
            marginThreshold={0}
          >
            {filtersContent}
          </Popover>
        </>
      ) : (
        // Big screen
        <Box
          sx={{
            display: "flex",
            gap: 2,
            alignItems: "center",
            justifyContent: "center",
            justifyItems: "center",
            position: "relative",
          }}
        >
          <FilterComponent
            onFilterChange={onFilterChange}
            filterData={filterData}
            observationData={observationData}
          />
          <DateRangeSlider
            onDateRangeSelected={onDateRangeSelected}
            dataSource={observationData}
          />
          <AOISelector onAOISelected={onAOISelected} AOIData={AOIData} />
        </Box>
      )}
    </>
  );
};

export default HomeFilters;
